export const pseudoLocales = ['en-XA', 'en-XB', 'xx-AC', 'xx-HA', 'xx-LS'] as const;

export const supportedLocales = ['en', ...pseudoLocales] as const;
